// extracted by mini-css-extract-plugin
export default {"divMain":"Contact_divMain__hufKN"};